import EventDispatcher from "ui/EventDispatcher";
import PaletteModel from "ui/canvas/models/PaletteModel";

/**
 * Event: Current color changed
 *
 * @type {string}
 */
export const EVENT_CHANGE_COLOR = 'change_color';

/**
 * Event: Current color slot changed
 *
 * @type {string}
 */
export const EVENT_CHANGE_SLOT = 'change_slot';

/**
 * Event: Opacity has been disabled or enabled
 *
 * @type {string}
 */
export const EVENT_DISABLE_OPACITY = 'disable_opacity';

/**
 * @type {number}
 */
const OPACITY_SLOTS = 5;

/**
 * Colors Set Model
 */
class ColorsSetModel extends EventDispatcher {
	/**
	 * Class constructor
	 */
	constructor() {
		super();
		/**
		 * @type {number}
		 * @private
		 */
		this._opacitySlot = 0;

		/**
		 * @type {string}
		 * @private
		 */
		this._color = new PaletteModel().getBlackColor().rgbaCss;
	}

	/**
	 * Changes color of the current slot
	 *
	 * @param {string} color
	 * @return {ColorsSetModel}
	 */
	changeCurrentSlotColor(color) {
		if (this._color === color) {
			return this;
		}

		this._color = color;
		this.trigger(EVENT_CHANGE_COLOR);
		return this;
	}

	/**
	 * Returns current color value
	 *
	 * @returns {string}
	 */
	getCurrentColor() {
		return this._color;
	}

	/**
	 * Sets current opacity slot
	 *
	 * @param {number} index
	 * @returns {ColorsSetModel}
	 */
	switchOpacitySlot(index) {
		const slot = Math.max(0, Math.min(OPACITY_SLOTS - 1, +index));

		if (this._opacitySlot === slot) {
			return this;
		}

		this._opacitySlot = slot;
		this.trigger(EVENT_CHANGE_SLOT);
		this.trigger(EVENT_CHANGE_COLOR);
		return this;
	}

	/**
	 * Returns opacity slot index
	 *
	 * @returns {number}
	 */
	getCurrentOpacitySlot() {
		return this._opacitySlot;
	}

	/**
	 * Returns current opacity normalized value (from 0 to 1)
	 *
	 * @returns {number}
	 */
	getCurrentOpacity() {
		return 1 - this._opacitySlot * (1 / OPACITY_SLOTS);
	}
}

export default ColorsSetModel;
